import {loadZonesInfo} from './C18utils'
import {getParamId2} from '../utils/utils'
import {dbVals, sendArray,} from '../../components/utils/http';
import {pInd,pi} from '../../components/utils/paramIds'
import {wsTrans} from '../utils/utils'
import {cl,globs,constant,getTime} from '../../components/utils/utils';

var aiGlobs={doserInfo:{schedule:[]}};
var jProMbPort=3
var equipNameId,equipTypeId,irrModeId
// match Pearl JPRO_ReadInfo
var jProRegs=["ec1","ec2","ph1","ph2","temp","flow","total",//1-7
    "cps0","cps1","cps2","cps3","cps4","cps5","cps6","cps7",//8-15
    "cps8","cps9","cps10","cps11","cps12","cps13","cps14","cps15",//16-23
    "ecHAl","ecLAl","phHAl","phLAl","kFact","total2"//24-29
             ]
var gsNames=["EC1","EC2","pH1","pH2","Temp","Flow","Volume","CPS0","CPS1","CPS2","CPS3","CPS4","CPS5","CPS6","CPS7","CPS8","CPS9","CPS10","CPS11","CPS12","CPS13","CPS14","CPS15","EC LoH","EC LoL","pH LoH","pH LoL","K Factor","Volume Hi"]

const senseIds={
// note gsEcId, etc. in C18AiUtils
  EC: {ind:0,gsId:0,id:22529,min:0,max:3,color:"brown",unit:"e"},
  pH: {ind:1,gsId:3,id:22541,min:4,max:10,color:"red"},
  Temp: {ind:2,gsId:4,id:22545,min:20,max:100,color:"#408080",unit:"t"},
  Flow: {ind:3,gsId:5,id:22549,min:0,max:100,color:"blue",unit:"v"},
}

var setSensorNames=(sensors)=>{
  gsNames.forEach((n,i)=>{sensors[`e0gn${i}`]=n})
}

var getIrrigationEvents=async(siteId,fromTs,toTs)=>{
//   cl("getIrrigationEvents")
//   let zones=[]
//   globs.zonesInfo.info.filter(z=>z.siteId==siteId).forEach(z=>zones[z.siteZoneIndex]=z)
  let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/irrigation",
    method: "retrieve", sessionId: globs.userData.session.sessionId,
    body: {
      siteId:siteId,
      cmd:"getCycles",
//       tz:(new Date()).getTimezoneOffset(),
      fromTs:fromTs,
      toTs:toTs,
    }})
//   let events=res.data.events
//   events.forEach(e=>{// add tz of controller
//     let [z,c]=e.key.split("-")
//     e.contTzo=zones[z].contTzo
//   })
  return res.data.events
//   return res && res.data !== undefined ? res.data : res
}

var getZone=(siteId,zoneInd)=>{
//   cl("getIrrigationEvents")
  return globs.zonesInfo.info.find(z=>
    (z.siteId==siteId)&&(z.siteZoneIndex==zoneInd))
}

var getChannel=(siteId,zoneInd,channelInd)=>{
//   cl("getIrrigationEvents")
//   cl(aiGlobs.channels)
  let ch=(aiGlobs.channels||{})[`${zoneInd}-${channelInd}`]
  if(!ch){return{}}
//   cl(ch)
  return{
    channelName:ch[equipNameId],
    channelType:ch[equipTypeId],
  }
//   return aiGlobs.channels.find(c=>(c.z==zoneInd)&&(c.c==channelInd))
}

var getRecipe=(zoneId,ts,tzo=-420,mode)=>{
//   cl("getIrrigationEvents")
  let dayMins=(ts+tzo*60)/60%1440
//   cl(aiGlobs.doserInfo.schedule)
  var schedRecipe
  if(mode=="simple"){
    schedRecipe=aiGlobs.doserInfo.schedule.find(s=>{
      return (s.dayMins<=dayMins)&&((s.dayMins+s.durMins)>dayMins)
    })
  }else{
    let advRecipe=aiGlobs.doserInfo.recipeSegments.find(s=>dayMins<s.end)
    schedRecipe={
      recipeId:advRecipe.recipeId,
      dayMins:advRecipe.start,
      durMins:advRecipe.end-advRecipe.start
    }
  }
//   cl(schedRecipe)
  var recipe
  if(schedRecipe){
    recipe=aiGlobs.doserInfo.recipes
      .find(r=>r.recipeId==schedRecipe.recipeId)
  }
//   cl(recipe)
  return recipe
}

var loadZoneInfo=async(siteId)=>{
//   cl("getIrrigationEvents")
  await loadZonesInfo()
}

var filterSchedIrr=(channels)=>{
//   cl(channels)
  let schedChs={}
  Object.keys(channels).forEach(k=>{
    let ch=channels[k]
    if((ch[equipTypeId]==constant.EQ_IRR)&&
      (ch[irrModeId]==constant.IRR_SCHEDULED)){
        schedChs[k]=ch
      }
  })
  return schedChs
//   cl(schedChs)
}

var loadChannelInfo2=()=>{
//   cl(dbVals)
  let ids=[equipNameId,equipTypeId,irrModeId]
  let chans={}
//   cl(dbVals.z)
  dbVals.z.forEach((z,zInd)=>{
    for(let ch=0;ch<128;ch++){// channels
      if(z&&z[ch][equipTypeId]){
        let key=`${zInd}-${ch}`
        chans[key]={}
        ids.forEach(id=>{
          chans[key][id]=z[ch][id]
        })
//         cl(zInd,ch,z[ch][equipTypeId])
      }
    }
  })
  aiGlobs.channels=chans
//   cl(chans)
}

var loadChannelInfo=async(siteId)=>{// only sched irr
  if(!siteId){return}
//   cl("getIrrigationEvents")
  equipNameId=getParamId2(1900,
    "configuration_channels","channelName")
  equipTypeId=getParamId2(1900,
    "configuration_channels","channelType")
  irrModeId=getParamId2(1900,
    "config_channels_configuration","irrigation_mode")
  return loadChannelInfo2()
//   let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/channels",
//     method: "retrieve", sessionId: globs.userData.session.sessionId,
//     body: {
//       siteId:siteId,
// //       pid:{$in:[equipNameId,equipTypeId]},
//     }})
//   res=res.data.filter(r=>(r.z!=null))
// //   cl(res)
//   let chans={}
//   res.forEach(r=>{
//     if((r.z!=null)&&(r.c!=null)){
//       let key=`${r.z}-${r.c}`
//       if(!chans[key]){chans[key]={}}
//       chans[key][r.i]=r.v
//     }
//   })
//   aiGlobs.channels={}
//   Object.keys(chans).forEach(key=>{
//     if(+chans[key][equipTypeId]){aiGlobs.channels[key]=chans[key]}
//   })
//   cl(aiGlobs)
}

var getChannelNames=()=>{
//   cl(aiGlobs.channels)
  let chanNames={}
  Object.keys(aiGlobs.channels).forEach(k=>{
    let [z,c]=k.split("-");
    if(!chanNames[z]){chanNames[z]={}}
    chanNames[z][c]=aiGlobs.channels[k]
  })
//   cl(chanNames)
  return chanNames
}

var getGenSensId=(ind)=>{
//   cl("getGenSensId")
  let mult=pInd[1900].pearl_gen_sens_stat[2]
  return pInd[1900].pearl_gen_sens_stat[0]+ind*mult+
    pi[1900].pearl_gen_sens_stat["adjValue"]
}

var gsEcId=0// generic sensors for J+
var gsPhId=3
var gsTempId=4
var gsVolId=5// actually, flow
var gsTotVolId=6

var loadRtdVals=async(zoneId,valId,fromTs,toTs)=>{
  valId=(valId!=null)?[valId]:[gsEcId,gsPhId,gsTempId,gsVolId,gsTotVolId,]
  let hist=await loadHistory(zoneId,valId,fromTs,toTs)
  let flow=hist[senseIds["Flow"].id]
//   if(flow){flow.forEach(f=>f.v*=10)}
  return hist
}

const expTable = [
    1.0000,
    0.6703,
    0.4493,
    0.3012,
    0.2019,
    0.1353,
    0.0907,
    0.0608,
    0.0408,
    0.0273,
    0.0183
];

function fastExp(x) {
  if (x <= 0) return 1;
  if (x >= 4) return 0;
  const p = x * 2.5;       // 0..4 -> 0..10
  const i = Math.floor(p);
  const f = p - i;
  return expTable[i] +
    f * (expTable[i + 1] - expTable[i]);
}

var compressHistory2=(input, period, k = 0.25)=>{
  input.sort((a,b)=>a.t-b.t)
  if (!input.length)
    return [];

  const output = [];
  const tc = period * k;
  const base = input[0].t;

  let xma = input[0].v;
  let lastT = input[0].t;

  for (const p of input) {
    if(![1e4,1e6].includes(+p.v)){
//       if(p.v>100){cl(p)}
      const dt = p.t - lastT;
      const alpha = 1 - fastExp(dt / tc);
      xma += alpha * (p.v - xma);
      const i = Math.floor((p.t - base) / period);
      output[i] = {
        t: p.t,
        v: xma
      };
      lastT = p.t;
    }
  }

  return output.filter(x => x !== undefined);
}

var loadHistory=async(zoneId,sensIds,fromTs,toTs)=>{
  if(!zoneId){return {}}
  let zone=globs.zonesInfo.info.find(z=>z.zoneId==zoneId)
  let pidArr=sensIds.map(s=>getGenSensId(s))
//   cl(sensIds)
//   let pid=getGenSensId(gsTotVolId)
  let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/zoneHistory",
    method: "retrieve", sessionId: globs.userData.session.sessionId,
    body: {
      siteId:zone?.siteId,
      zInd:zone?.siteZoneIndex,
      fromTs:fromTs,
      toTs:toTs,
      pidArr:pidArr,
    }})
  let ret={}
  res.data.forEach(r=>{
    if(!ret[r.i]){ret[r.i]=[]}
    ret[r.i].push({t:r.t,v:+r.v})
  })
//   cl(ret)
  Object.keys(ret).forEach(k=>{
//     cl(ret[k][0])
    ret[k].sort((a,b)=>{return a.t-b.t})
    let lastVal=Object.assign({},ret[k].at(-1))
    lastVal.t=toTs
    ret[k].push(lastVal)
    let firstVal=Object.assign({},ret[k][0])
    firstVal.t=fromTs
    ret[k].unshift(firstVal)
    let period=(toTs-fromTs)/2e3
    ret[k]=compressHistory2(ret[k],period)
  })
//   cl(ret)
  return ret
//   let vols=res.data.map(r=>{
//     return {t:r.t,v:r.v}
//   })
//   vols.sort((a,b)=>{return a.v-b.v})
//   aiGlobs.volume=vols
//   cl(vols)
}

var loadIrrigationVolume=async(zoneId,fromTs,toTs)=>{
//   cl("loadIrrigationVolume")
  let res=await loadHistory(zoneId,[gsTotVolId],fromTs,toTs)
//   cl(gsTotVolId)
//   if(!zoneId){return}
//   let zone=globs.zonesInfo.info.find(z=>z.zoneId==zoneId)
//   let pid=getGenSensId(gsTotVolId)
//   let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/zoneHistory",
//     method: "retrieve", sessionId: globs.userData.session.sessionId,
//     body: {
//       siteId:zone?.siteId,
//       zInd:zone?.siteZoneIndex,
//       fromTs:fromTs,
//       toTs:toTs,
//       pidArr:[pid],
//     }})
//   let vols=res.data.map(r=>{
//     return {t:r.t,v:r.v}
//   })
//   vols.sort((a,b)=>{return a.v-b.v})
  aiGlobs.volume=res[getGenSensId(gsTotVolId)]//vols
//   cl(aiGlobs.volume)
//   cl(vols)
}

var loadRecipes=async(zoneId)=>{
//   cl("loadRecipes")
  let body={
    zoneId:zoneId,
  }
  let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/pearlDoser", method: "retrieve",
    sessionId: globs.userData.session.sessionId, body: body})
//   aiGlobs.doserInfo={}
//   cl(res)
  res.data.forEach(r=>aiGlobs.doserInfo[r.type]=r.value)
//   aiGlobs.doserInfo=res
//   cl(aiGlobs.doserInfo.recipeSegments)
}

var getVolume=(zoneId,fromTs,toTs)=>{
//   cl("getIrrigationEvents")
  let range=aiGlobs.volume.filter(v=>(v.t>=fromTs)&&(v.t<toTs))
  if(range.length<2){return 0}
//   cl(range)
//       cl(aiGlobs)
//   cl(fromTs,toTs)
//   cl(range)
//   cl(aiGlobs.volume)
  return (range.at(-1).v||0)-(range[0].v||0)
//   return (toTs-fromTs)/15
}

var getTabPid=(tab,col,row)=>{
  let mult=pInd[1900][tab][2]
  if([
    "zone_configuration_settings",
    "controller_configuration_settings"
  ].includes(tab)){
    return pInd[1900][tab][0]+2*pi[1900][tab][col]+1
  }else{
    return pInd[1900][tab][0]+row*mult+
      pi[1900][tab][col]
  }
}

var getDb=(zInd,chan,tab,col,row)=>{
  let pid=getTabPid(tab,col,row)
  return dbVals.z[zInd]?.[chan]?.[pid]
}

var setDb=(arr,zInd,chan,tab,col,row,val)=>{
  let pid=getTabPid(tab,col,row)
  dbVals.z[zInd][chan][pid]=val// update local copy
  arr.push({
    z: zInd,
    c: chan,
    i: pid,
    f: 2,
    t:(new Date())/1000,
    d: val
  })
}

var sendArrayDb=async(arr)=>{
  let r=await sendArray(arr,false,1900,null,false)
}

// var genSensePid=getParamId2(1900,"pearl_gen_sens_stat","adjValue");
// var genSenseMult=pInd[1900].pearl_gen_sens_stat[2];

var genSensePid
var genSenseMult=genSenseMult=pInd[1900].pearl_gen_sens_stat[2];
// var jproId="ECpH"

var jpGenSense={// map to genSense index
  ec: 1,
  ph: 4,
  temp: 5,
  flow: 6,
  volume: 7,
  cps0: 8,
  cps1: 9,
  cps2: 10,
  cps3: 11,
  cps4: 12,
  cps5: 13,
  cps6: 14,
  cps7: 15,
  cps8: 16,
  cps9: 17,
  cps10: 18,
  cps11: 19,
  cps12: 20,
  cps13: 21,
  cps14: 22,
  cps15: 23,
  ecHiAlrm: 24,
  ecLoAlrm: 25,// need to be updated
  phHiAlrm: 26,
  phLoAlrm: 27,
  kFactor: 28,
  volHi: 29,
}

var getGenSense=(zInd,ind)=>{
//   cl(zInd,240,genSensePid,genSenseMult,genSensePid+genSenseMult*ind)
//   cl(+dbVals.z[zInd][240][genSensePid+genSenseMult*ind])
  return +dbVals.z[zInd][240][genSensePid+genSenseMult*ind]||0
}

var getJProBoards=(xBoards)=>{
// return an array of the boardIds of jPro
  let jProBoards=[];
  (xBoards||[]).forEach((xb,i)=>{
    if([constant.MB_SLAVE_TYPE_JPRO,constant.MB_SLAVE_TYPE_JPLUS]
      .includes(xb.typeId)){jProBoards.push(i)}
//     if(xb.typeId==constant.MB_SLAVE_TYPE_JPRO){jProBoards.push(i)}
  })
  return jProBoards
}

var readJPro=(zInd,xBoards,jPlusCnt)=>{
//this should return an *array* of jPro
//   let jProInd=0
//   cl(jPlus)

  genSensePid=getParamId2(1900,"pearl_gen_sens_stat","adjValue");
//   cl(genSensePid)
  let jProBoards=getJProBoards(xBoards)
  let jpArr=[]
  for(let i=0;i<jPlusCnt;i++){
    let jpVals={}
    let keys=Object.keys(jpGenSense)
    keys.forEach(g=>{
      let ind=i*keys.length+jpGenSense[g]-1
//       cl(g)
      jpVals[g]=getGenSense(zInd,ind)
    })
//     cl(jpVals)
    jpVals.cps=[...Array(16).keys()].map(c=>+jpVals[`cps${c}`])
    jpVals.board=jProBoards[i]
    jpArr.push(jpVals)
//     cl(jpVals)
  }
//   cl(jpArr)
  return jpArr
}

var jProIds
var xBoardIds=["numOutId","chIndex","typeId","addIndex","numInps",
  "startInp","mbPort",]
var xbMult=pInd[1900].config_expansion_boards[2]

// much of this is copied from C18ModbusGP01.js
var initJProIds=()=>{
  if(jProIds){return}
  jProIds={}
  jProIds.genSensePid=getParamId2(1900,"pearl_gen_sens_stat","adjValue");
  let ceb="configuration_expansion_boards"
  let gwType=1900
  jProIds.xb={
    numOutId:getParamId2(gwType,ceb,"numOutputs"),
    chIndex:getParamId2(gwType,ceb,"startChannelIndex"),// starting output
    addIndex:getParamId2(gwType,ceb,"address"),
    typeId:getParamId2(gwType,ceb,"boardType"),
    numInps:getParamId2(gwType,ceb,"numInputs"),
    startInp:getParamId2(gwType,ceb,"startInput"),
    mbPort:getParamId2(gwType,ceb,"modbusPort"),
//     uniqueId1:getParamId2(gwType,xca,"uniqueId1"),
//     zoneUid:getParamId2(gwType,xca,"zoneUid"),
  }
}

var loadXBoards=(zInd)=>{
  initJProIds()
  let id=jProIds.xb.typeId
  let ch=dbVals.z[zInd][240]
  let xBoards=Array(constant.CONT_NUM_XBOARDS)
  for(let i=0;i<constant.CONT_NUM_XBOARDS;i++){
    let type=ch[id+xbMult*i]
    if(type!=constant.MB_SLAVE_TYPE_NONE){
      xBoards[i]={typeId:type,}
      xBoardIds.forEach(id=>{
        xBoards[i][id]=+ch[jProIds.xb[id]+xbMult*i]
      })
    }
  }
//     cl(xBoards)
  return xBoards
}

var readXBoards=(zInd)=>{
  let xBoards=loadXBoards(zInd)
//   cl(xBoards)
  return xBoards
}

var c={
  STCO_STATUS:0x00,// bit 2,3
  STCO_OUTPUT:0x04,
  STCO_CONFIG:0x08,
  STCO_MASK:0x0C,
  STCO_SHIFT:2,
}

var addJProstoXB=(xBoards,jPros,jProInOut,jProType)=>{
// go through xBoards, update channels, jPro entries
// add new jPros at end
  let chIndex=0
  let startInp=0
  let jProInd=0
//   cl(jPros)
  for(let i=0;i<xBoards.length;i++){
    let xb=xBoards[i]
//     cl(jProInd)
//     cl(xb)
    if(!xb){// reached the current end of xBoards
//       cl("end")
      if(jProInd>=jPros.length){break}// done
      xb={typeId:constant.MB_SLAVE_TYPE_JPRO}// init jPro - will be changed
      xBoards[i]=xb
//       cl(xb)
    }
//     cl(xb)
    xb.chIndex=chIndex
    xb.startInp=startInp
    if([constant.MB_SLAVE_TYPE_JPRO,constant.MB_SLAVE_TYPE_JPLUS].includes(xb.typeId)){
      let typeId=(jPros[jProInd]?.type=="jPlus")?
        constant.MB_SLAVE_TYPE_JPLUS:
        constant.MB_SLAVE_TYPE_JPRO
//       cl(typeId)
//     if(xb.typeId==jProType){// if jPro
//       cl(jProInd,jPros.length)
//       cl(jPros[jProInd].type)
      if(jProInd<jPros.length){// add/update jPro
        xb.mbPort=jProMbPort
        xb.numOutId=jProInOut.numOut
        xb.numInps=jProInOut.numInp
        xb.addIndex=jPros[jProInd].mbAddr
        xb.typeId=typeId
        jProInd++
      }else{
        xBoards[i]=null
      }
    }
//     cl(xBoards)
    chIndex+=xb.numOutId
    startInp+=xb.numInps
  }
//   cl(xBoards)
}

var sendXBoard=(arr,zInd,xb,xbInd)=>{
// add to arr, and update xBoards state
// xb can be null, meaning erase - set to 0's
//     cl(`send xboard ${xbInd}`)
  xBoardIds.forEach(id=>{
    arr.push(({
      z: +zInd,
      c: 240,
      i: jProIds.xb[id]+xbInd*xbMult,
      f:2,
      t: Math.floor(getTime()),
      d: (xb||{})[id]||0,
    }));
  })
//     let xBoards=this.state.xBoards.slice(0)
//     xBoards[xbInd]=xb
//     this.setState({xBoards:xBoards})
}

var sendXBoards=async(xBoards,zInd)=>{
  let arr=[]
//   cl("sendXBoards")
//   cl(xBoards)
  xBoards.forEach((xb,i)=>{
//     cl(xb)
    sendXBoard(arr,zInd,xb,i)
  })
//   cl(arr)
  let ret=await sendArray(arr,0,1900,0,false)
}

var checkValRange=(val,min,max)=>{
  if(val==0){return 0}
  let isNeg=val<0
  if(isNeg){
    min=0-min
    max=0-max
  }
  if(isNeg^(val>max)){val=max}
  if(isNeg^(val<min)){val=min}
  return val
}

var floatTo16Conv=(val)=>{
  val=checkValRange(val,.000031,131000)
  var buf=new Buffer(4)
  buf.writeFloatLE(val,0)
  let hex=buf.readInt32LE(0)>>>0
//     cl(hex)
  let sign=(hex&0x80000000)>>>16
  let exp=((hex&0x7F800000)>>>13)
  if(exp){exp-=(112<<10)}
  let mant=(hex&0x007FFFFF)>>>13
  return(sign|exp|mant)&0x0FFFF
}

var saveJPros=async(zInd,jPros,xBoards)=>{
//   cl(jPros)
//   cl(xBoards)
  await saveGenSense(zInd,0,0)
  let jProInOut={numInp:jProRegs.length,numOut:0}
  addJProstoXB(xBoards,jPros,jProInOut,constant.MB_SLAVE_TYPE_JPRO)
  await sendXBoards(xBoards,zInd)
//   cl(xBoards)
  return xBoards
}

var schedIds
var vpsId
var schedMult=pInd[1900].pearl_jpro[2]

var initSchedIds=()=>{
  if(schedIds){return}
  let pjp="pearl_jpro"
  schedIds={
    start:getParamId2(1900,pjp,"start"),
    end:getParamId2(1900,pjp,"end"),
    kFact:getParamId2(1900,pjp,"kFact"),
    board:getParamId2(1900,pjp,"board"),
  }
  vpsId=getParamId2(1900,pjp,"vp00");
//   let vpsId=getParamId2(1900,pjp,"vp00");
//   [...Array(16).keys()].forEach(i=>{
//     schedIds[`vp${("00"+i).slice(-2)}`]=vpsId+i
//   })
//   cl(schedIds)
}

var sendSchedule=async(schedule,zInd)=>{
//   cl(schedule)
  cl("sendSchedule")
  let arr=[]
  schedule.forEach((sched,i)=>{
    Object.keys(schedIds).forEach(id=>{
      arr.push({
        z: +zInd,
        c: 240,
        i: schedIds[id]+i*schedMult,
        f:2,
        t: Math.floor(getTime()),
        d: sched[id],
      })
    });
    sched.vps.forEach((vps,j)=>{// vps values
      arr.push({
        z: +zInd,
        c: 240,
        i: vpsId+i*schedMult+j,
        f:2,
        t: Math.floor(getTime()),
        d: (vps<0x10000)?vps:0xFFFF,
      })
    })
  })
//   cl(arr)
  let ret=await sendArray(arr,0,1900,0,false)
}

var contSaveSchedule=async(schedule,recipes,jPlus,jPro,zInd)=>{
//   cl(recipes)
  let useJPro=jPro//jPlus.filter(j=>!j.notUsed)
//   cl(jPro)
  let schdCnt=12/useJPro.length
  let contScheds=[]
  initSchedIds()
  for(let sched of schedule){
    let recipe=recipes.find(r=>r.recipeId==sched?.recipeId)
//     cl(recipe)
    if(recipe){
      for(let i=0;i<jPro.length;i++){
        if(!jPlus[i].notUsed){
          let jp=jPro[i]
//           cl(jp.cps)
//           cl(recipe.concs.slice(16*i,16*(i+1)))
          contScheds.push({
            start:sched.dayMins,
            end:sched.dayMins+sched.durMins,
            kFact:50,
            board:jp.board,
            vps:recipe.concs.slice(16*i,16*(i+1)).map((c,j)=>{
              if(c){
                let vps=Math.round(100*jp.cps[j]/c)
                return (vps)?vps:0xFFFF
              }else{
                return 0xFFFF
              }
//               return (c)?Math.round(100*jp.cps[j]/c):0),
            })
          })
        }
      }
//       cl(recipe)
    }
  }
//   cl(contScheds)
  await sendSchedule(contScheds,zInd)
//   cl(contScheds)

//   cl(jpCnt)
//   cl(schedule)
//   cl(recipes)
//   cl(jPlus)
//   cl("contSaveSchedule")
}

var gsIds


var initGsIds=()=>{
  if(gsIds){return}
  let arr=Array(jProRegs.length).fill({slp:.01,ofs:0})
  let pgsc="pearl_gen_sens_conf"
//   cl(arr)
  gsIds={
    gsMbMapId:getParamId2(1900,pgsc,"mapping"),
    gsTypeId:getParamId2(1900,pgsc,"sensorType"),
    gsBrdId:getParamId2(1900,pgsc,"board"),
    gsChanId:getParamId2(1900,pgsc,"channel"),
    gsSlopeId:getParamId2(1900,pgsc,"slope"),
    gsOfsId:getParamId2(1900,pgsc,"calibrate"),
    gsPgscMult:pInd[1900].pearl_gen_sens_conf[2],
//     gsPscMult:pInd[1900].pearl_sensor_config[2],
    gsCalArr:arr,
  }

}

var setGenSense=(arr,zInd,gsId,type,brd,chan)=>{// + constant.GEN_SENSE0
  initGsIds()
  var addArr=(pid,gsId,gsMult,val)=>{
    let gsPid=pid+gsId*gsMult
    let cur=dbVals.z[zInd][240][gsPid]
    if(cur!=val){
      arr.push(({
        z: +zInd,
        c: 240,
        i: gsPid,
        f:2,
        t: Math.floor(getTime()),
        d: val||0,
      }));
    }
  }
  addArr(gsIds.gsMbMapId,gsId,gsIds.gsPgscMult,constant.INPUTNAME_MBUS_INPUT)
  addArr(gsIds.gsTypeId,gsId,gsIds.gsPgscMult,type)
  addArr(gsIds.gsBrdId,gsId,gsIds.gsPgscMult,brd)
  addArr(gsIds.gsChanId,gsId,gsIds.gsPgscMult,chan)
  addArr(gsIds.gsSlopeId,gsId,gsIds.gsPgscMult,gsIds.gsCalArr[gsId].slp)
  addArr(gsIds.gsOfsId,gsId,gsIds.gsPgscMult,gsIds.gsCalArr[gsId].ofs)
//   cl(arr)
}

var saveGenSense=async(zInd,xbInd,jpInd)=>{// for one jPro
//   cl("saveGenSense")
  let re2Type={
    "ec":constant.GENTYPE_EC,
    "ph":constant.GENTYPE_PH,
    "te":constant.GENTYPE_GTEMP,
    "fl":constant.GENTYPE_FLOW,
    "to":constant.GENTYPE_GEN,
    "cp":constant.GENTYPE_GEN,
    "kF":constant.GENTYPE_GEN,
  }
  let regCnt=jProRegs.length
//   cl("save Gen Sense")
  let arr=[]
  jProRegs.forEach((r,i)=>{
    setGenSense(arr,zInd,jpInd*regCnt+i,re2Type[r.substring(0,2)],xbInd,i)
  })
//   cl(arr)
  let ret=await sendArray(arr,0,1900,0,false)
}

var withTimeout=async (promise, ms)=>{
  return Promise.race([
    promise,
    new Promise((r,e) =>setTimeout(() => r("to"), ms))
  ]);
}


var doSave = async (field, value, zoneId) => {
//   cl(field)
//   cl(value)
//   cl(zoneId)
//     const pa = this.props.parms;
    cl(`save ${field}`)
    await wsTrans("usa", {
      cmd: "cRest",
      uri: "/s/pearlDoser",
      method: "update",
      sessionId: globs.userData.session.sessionId,
      body: {
        zoneId,//: pa.zone,
        type: field,
        value,
      }
    });
  };

var badGSValue=(v)=>{return [1e6,1e4].includes(+v)}

export{getIrrigationEvents,getZone,getChannel,getRecipe,loadZoneInfo,
  loadChannelInfo,loadIrrigationVolume,loadRecipes,getVolume,getDb,
  setDb,sendArrayDb,readJPro,readXBoards,loadRtdVals,
  saveJPros,contSaveSchedule,getChannelNames,senseIds,withTimeout,
  setSensorNames,getJProBoards,doSave,aiGlobs,filterSchedIrr,badGSValue,
}

